export const EnergyEfficiencyColorMap = {
  'generic': '#b3b9c2',
  'A+++': '#02964d',
  'A++': '#00aa02',
  'A+': '#aac800',
  'A': '#f3f300',
  'B': '#fecd43',
  'C': '#ff7e02',
  'D': '#fe0000',
  'E': '#e00001',
  'F': '#c80101',
};
